import EfSectionLR from '@elem/ui/ef-section-l-r';
import styles from './index.module.scss';
import { useLang } from '@/i18n';

export default function TheComp() {
    const { t } = useLang('theProduct.SectionLRB');
    return (
        <div className={styles.TheComp}>
            <EfSectionLR
                pc="https://websiteoss.ecoflow.com/upload/image/1725605169435/pc_BMS.jpg"
                h5="https://websiteoss.ecoflow.com/upload/image/1725605217391/m_BMS.jpg"
                label={t('label')}
                title={t('title')}
                desc={t('desc')}
            />
        </div>
    );
}
